<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="供应商：">
          <el-select v-model="formInline.supplyKeyId" placeholder="请选择供应商" clearable size="small">
            <el-option v-for="item in supplyList" :label="item.name" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入库单号：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.inputStoreNo"
            placeholder="请输入入库单号"></el-input>
        </el-form-item>
        <el-form-item label="商品信息：">
          <el-cascader size="small" v-model="formInline.typeKeyId" :options="goodsTypeList" :props="cascaderProps"
            @change="handleTypeChange" placeholder="请选择商品信息" clearable filterable></el-cascader>
        </el-form-item>
        <el-form-item label="球镜">
          <el-select v-model="formInline.paramsKeyId1" placeholder="请选择球镜" clearable filterable size="small"
            @change="handleParamsChange">
            <el-option v-for="item in qiuJingList" :label="item.paramsValue" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="柱镜">
          <el-select v-model="formInline.paramsKeyId2" placeholder="请选择柱镜" clearable filterable size="small"
            @change="handleParamsChange">
            <el-option v-for="item in zhuJingList" :label="item.paramsValue" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入库时间：">
          <el-date-picker v-model="inputDateList" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" @change="changeDate" clearable
            size="small" />
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button v-if="this.$checkBtnPermission('/inputStoreDtl/index', 'viewPage')" size="small" type="primary"
            class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-button v-if="this.$checkBtnPermission('/inputStoreDtl/index', 'reset')" size="small"
            icon="el-icon-refresh" @click="clearAll">重置</el-button>
          <my-column-filter v-if="this.$checkBtnPermission('/inputStoreDtl/index', 'myFilter')"
            :listColumns="listColumns" @hidePop="getCheckBox"></my-column-filter>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading" border>
        <el-table-column v-if="isShowMoney" slot="price" label="单价" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.price }}
          </template>
        </el-table-column>
        <el-table-column v-if="isShowMoney" slot="money" label="金额" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.money }}
          </template>
        </el-table-column>
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
  </div>
</template>

<script>
import { getSupplyInfoList } from "@/api/baseDataApi.js";
import { GetInputStoreDtlPageList } from "@/api/receiptApi.js";
import {
  GetAllGoodsTypeTreePageList,
  GetGoodsParamsList,
} from "@/api/baseDataApi.js";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "顾客列表",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      supplyList: [],
      selectionList: [],
      inputDateList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        supplyKeyId: "",
        typeKeyId: "",
        paramsKeyId1: "",
        paramsKeyId2: "",
        inputStoreNo: "",
        startTime: null,
        endTime: null,
      },
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "inputStoreNo",
          label: "入库单号",
          align: "center",
          minWidth: "220",
        },
        {
          prop: "inputDate",
          label: "入库时间",
          align: "center",
          minWidth: "160",
        },
        {
          prop: "supplyName",
          label: "供应商",
          align: "center",
          minWidth: "120",
        },
        {
          prop: "goodsInfo.type",
          label: "商品品牌",
          align: "center",
          isKeep: true,
          minWidth: "120",
        },
        {
          prop: "goodsInfo.name",
          label: "商品名称",
          align: "center",
          minWidth: "160",
        },
        {
          prop: "goodsInfo.qiuJing",
          label: "球镜",
          minWidth: "80",
          align: "center",
        },
        {
          prop: "goodsInfo.zhuJing",
          label: "柱镜",
          align: "center",
          minWidth: "80",
          align: "center",
        },
        {
          slot: "price",
          label: "单价",
          align: "center",
          minWidth: "80",
          align: "center",
        },
        {
          prop: "quantity",
          label: "数量",
          align: "center",
          minWidth: "80",
          align: "center",
        },
        {
          slot: "money",
          label: "金额",
          align: "center",
          minWidth: "80",
          align: "center",
        },
        {
          prop: "creator",
          label: "创建人",
          align: "center",
          minWidth: "80",
        },
        {
          prop: "createTime",
          label: "创建时间",
          align: "center",
          minWidth: "150",
        },
        {
          prop: "editor",
          label: "维护人",
          align: "center",
          minWidth: "80",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          align: "center",
          minWidth: "150",
        },
      ],
      isShowMoney: false,
      goodsTypeList: [],
      qiuJingList: [],
      zhuJingList: [],
      cascaderProps: {
        value: "keyId", // 绑定值的属性名
        label: "name", // 显示文本的属性名
        children: "subList", // 子节点的属性名
        checkStrictly: false, // 可以选择任意一级
        expandTrigger: "click", // 展开方式
      },
    };
  },
  // 注册组件
  components: {},
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.getSupplyInfoList();
    this.GetAllGoodsTypeTreePageList();
    this.GetGoodsParamsList();
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata.roleInfo.keyId == "2f91e757a9c4444dbe13146a363a717c") {
      this.isShowMoney = true;
    } else {
      this.isShowMoney = false;
    }
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    // 获取供应商
    getSupplyInfoList() {
      const paramer = {};
      getSupplyInfoList(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.supplyList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取供应商信息失败!");
        });
    },
    changePages() { },
    // 获取列表
    getListData() {
      this.loading = true;
      GetInputStoreDtlPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.search();
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 时间选择
    changeDate(val) {
      if (val) {
        this.formInline.startTime = val[0];
        this.formInline.endTime = val[1];
      } else {
        this.formInline.startTime = null;
        this.formInline.endTime = null;
      }
    },
    // 处理商品类型选择变化
    handleTypeChange(value) {
      if (value && value.length > 0) {
        // 取最后一级的值作为typeKeyId
        this.formInline.typeKeyId = value[value.length - 1];
      } else {
        this.formInline.typeKeyId = "";
      }
      this.search();
    },
    // 获取商品类型数据
    GetAllGoodsTypeTreePageList() {
      GetAllGoodsTypeTreePageList({})
        .then((res) => {
          if (res.code == 1) {
            this.goodsTypeList = res.data;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    //获取商品参数信息
    GetGoodsParamsList() {
      GetGoodsParamsList({})
        .then((res) => {
          if (res.code == 1) {
            this.qiuJingList = res.data.filter((item) => item.type == 1);
            this.zhuJingList = res.data.filter((item) => item.type == 2);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 处理商品参数选择变化
    handleParamsChange(value) {
      this.search();
    },
  },
};
</script>

<style scoped>
.one_1 {
  padding: 2px 20px;
  background: #e6f7ff;
  border: 1px solid #6acaf3;
  color: #56bbfd;
  border-radius: 2px;
}

.one_2 {
  padding: 2px 20px;
  background: #fcd4ff;
  border: 1px solid #dfbce2;
  color: #ea7cff;
  border-radius: 2px;
}
</style>